module.exports = "{% if subcategorias | length == 0 %}\n\t<a href=\"produtos/index/{{ titulo | linkfy }}-{{ id }}\">{{ titulo }}</a>\n{% else %}\n\t<a href=\"javascript:void(0)\">{{ titulo }} {% if subcategorias | length > 0 %}+{% endif %}</a>\n\t<ul class=\"list-acordeon target-acordeon\">\n\t\t{% for subcategoria in subcategorias %}\n\t\t\t<li>\n\t\t\t\t<a href=\"produtos/index/{{ titulo | linkfy }}-{{ id }}/{{ subcategoria | linkfy }}\">{{ subcategoria.titulo }}</a>\n\t\t\t</li>\n\t\t{% endfor %}\n\t</ul>\n{% endif %}"


//////////////////
// WEBPACK FOOTER
// ./views/cardapio/categoria.twig
// module id = 24
// module chunks = 0